import _objectSpread from "E:\\Workspaces\\VScode\\vue3+TS\\vue\u6848\u4F8B\\cloudMusicProject-master\\node_modules\\@babel\\runtime\\helpers\\esm\\objectSpread2.js";
import "core-js/modules/es.array.map.js";
import { defineComponent, ref, toRefs } from "vue";
import Loading from "@/baseui/loading/loading.vue";
import { useStore } from "vuex";
import { useState } from "@/hooks/mapGet/index.js";
export default defineComponent({
  name: "newMusic",
  props: {
    newMusicList: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  setup: function setup(props) {
    var state = useState("player", ["currentId"]);
    var store = useStore();

    var _toRefs = toRefs(props),
        newMusicList = _toRefs.newMusicList;
    /* 存储被点击的id */


    var isActive = ref(-1);
    /* 点击播放新歌 */

    var itemClick = function itemClick(id) {
      isActive.value = id; //存储当前列表所有歌曲id为数组

      var songIds = newMusicList.value.map(function (song) {
        return song.id;
      }); //播放当前歌曲

      store.dispatch("player/setSongListByIds", {
        ids: songIds,
        currentId: id
      });
    };

    return _objectSpread(_objectSpread({}, state), {}, {
      isActive: isActive,
      itemClick: itemClick
    });
  },
  components: {
    Loading: Loading
  }
});